export default __webpack_public_path__ + "maps-examples-offline-storage-thumbnail-480-2227799ac76edf3a245fea62caadc8d3.png";